import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  AlertDialog,
  type AlertDialogProps,
  HtmlFormatter,
  Typography,
} from '@didaskill/ui/design-system';

import messages from './QuestionItemRemoveAlertDialog.messages';

export type QuestionItemRemoveAlertDialogProps = AlertDialogProps & {
  questionLabel?: string;
};

export const QuestionItemRemoveAlertDialogBase = ({
  questionLabel = null,
  ...props
}: QuestionItemRemoveAlertDialogProps) => (
  <AlertDialog variant={AlertDialog.VARIANTS.WARNING} {...props}>
    <HtmlFormatter>
      <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
        <FormattedMessage {...messages.REMOVE_QUESTION} />
      </Typography>

      <Typography variant={Typography.VARIANTS.HEADING_4}>{questionLabel}</Typography>
    </HtmlFormatter>
  </AlertDialog>
);

QuestionItemRemoveAlertDialogBase.displayName = 'QuestionItemRemoveAlertDialog';

export const QuestionItemRemoveAlertDialog = memo(QuestionItemRemoveAlertDialogBase);
